<div class="container">
  <div class="header">
    <div class="page_title_close_btn">
      <app-page-close-button (click)="goBack()"></app-page-close-button>
      <div class="page_title">
        @if (readOnlyMode) {
          View
        } @else if (editingEnabled) {
          Edit
        } @else {
          Create
        }
        Credit Note
      </div>
    </div>

    <div class="save_cancel_btn">

      @if (!readOnlyMode) {
        <button class="secondary_button" (click)="goBack()">Cancel</button>
        <button class="primary_button add_new_btn" (click)="save()">
        <span>
          @if (editingEnabled) {
            Update
          } @else {
            Save
          }
        </span>
        </button>
      } @else {
        <button class="secondary_button add_new_btn" (click)="goBack()">Go Back</button>
      }
    </div>
  </div>
  <div class="content">
    <div class="card">
      <app-dynamic-form
        [formConfig]="creditNoteFormConfig"
        [formGroup]="creditNoteForm"
        (onValueChange)="handleValueFormValueChange($event)"
      >
      </app-dynamic-form>
      <div class="notes" *ngIf="invoiceData !== undefined">
        <div class="invoice_icon">
          <app-svg-icon [path]="'assets/icons/invoice_icon.svg'"></app-svg-icon>
        </div>
        <div class="text">Invoice Total Amount:
          <div class="amount">{{ invoiceData?.amount?.totalAmount || invoiceData?.amount }}</div>
        </div>

      </div>
    </div>
  </div>

</div>
